import { StateContext } from '@ngxs/store';
import { ExhibitionStateModel } from '../exhibition.state';
import { ChangeEditMode } from '../exhibition.state.actions';

export const changeEditMode = (ctx: StateContext<ExhibitionStateModel>, action: ChangeEditMode) => {
    ctx.patchState({
        editable: action.payload.editable
    });
};
